import { HotelSection } from '../../components';

const Hotel = () => {
  return (
    <section>
      <HotelSection />
    </section>
  );
};

export default Hotel;
